import React from 'react'
import { VictoryLine, VictoryChart, VictoryAxis, VictoryLegend } from 'victory'



const ReturnChart = ( { data } ) => {

    const nfelo_close_color = '#ff4d70'
    const nfelo_open_color = '#ff4db8'
    const qbelo_close_color = '#914dff'
    const qbelo_open_color = '#4d5fff'

    const chartDataRaw = data.allScoredModelsCsv.nodes.map(node => {

            return (
                {
                    season: parseFloat(node.week_id),
                    nfelo_open: parseFloat(node.nfelo_open_ats_be_return_all_time),
                    nfelo_close: parseFloat(node.nfelo_close_ats_be_return_all_time),
                    qbelo_open: parseFloat(node.qbelo_open_ats_break_even_return_all_time),
                    qbelo_close: parseFloat(node.qbelo_close_ats_break_even_return_all_time),
                    zero: 0,
                }
            )

    })

    const chartData = chartDataRaw.filter(function(item){
        if (item.season > 2008.99) {
            return true
        } else {
            return false
        }
    })

    return (
        <VictoryChart
            domainPadding={{y:[15,15]}}
            width={550}
            height={300}
            >
            <VictoryLegend
                orientation='horizontal'
                x={135}
                y={10}
                symbolSpacer={6}
                data={[
                    {
                        name: 'nfelo (close)',
                        strokeColor : nfelo_close_color,
                        strokeOpac : 1,
                        strokeDash : 0,
                    },
                    {
                        name: 'nfelo (open)',
                        strokeColor : nfelo_open_color,
                        strokeOpac : 1,
                        strokeDash : 3,
                    },
                    {
                        name: '538 (close)',
                        strokeColor : qbelo_close_color,
                        strokeOpac : 1,
                        strokeDash : 0,
                    },
                    {
                        name: '538 (open)',
                        strokeColor : qbelo_open_color,
                        strokeOpac : 1,
                        strokeDash : 3,
                    },
                ]}
                style={{
                    data: {
                        fill : 'none',
                        stroke : ({datum}) => datum.strokeColor,
                        opacity : ({datum}) => datum.strokeOpac,
                        strokeDasharray : ({datum}) => datum.strokeDash,
                    },
                    labels: {
                        fill : ({datum}) => datum.strokeColor,
                        opacity : ({datum}) => datum.strokeOpac,
                        fontSize: 10,
                    }
                }}
            />
            <VictoryAxis
                label='Season'
                style={{
                    axisLabel: {
                        fontSize: '12px',
                        padding: '30',
                    },
                    tickLabels: {
                        fontSize: '10px',
                        color: '#808080',
                    },
                }}
                orientation='bottom'
                offsetY={50}
            />
            <VictoryAxis
                dependentAxis
                style={{
                    tickLabels: {
                        fontSize: '10px',
                        color: '#808080',
                    }
            }}
            />
            <VictoryLine
                style={{
                    data: {
                        stroke : '#000000',
                        opacity: .55,
                    },
                    labels: {
                        fontSize : 12
                    }
                }}
                data={chartData}
                x='season'
                y='zero'
            />
            <VictoryLine
                style={{
                    data: {
                        stroke : nfelo_close_color,
                        opacity: .65,
                    },
                    labels: {
                        fontSize : 12
                    }
                }}
                data={chartData}
                x='season'
                y='nfelo_close'
            />
            <VictoryLine
                style={{
                    data: {
                        stroke : nfelo_open_color,
                        opacity: .45,
                        strokeDasharray: 3,
                        strokeWidth: 1,
                    },
                    labels: {
                        fontSize : 12
                    }
                }}
                data={chartData}
                x='season'
                y='nfelo_open'
            />
            <VictoryLine
                style={{
                    data: {
                        stroke : qbelo_close_color,
                        opacity: .65,
                    },
                    labels: {
                        fontSize : 12
                    }
                }}
                data={chartData}
                x='season'
                y='qbelo_close'
            />
            <VictoryLine
                style={{
                    data: {
                        stroke : qbelo_open_color,
                        opacity: .45,
                        strokeDasharray: 3,
                        strokeWidth: 1,
                    },
                    labels: {
                        fontSize : 12
                    }
                }}
                data={chartData}
                x='season'
                y='qbelo_open'
            />
        </VictoryChart>
    )

}

export default ReturnChart